/**
 * @type {string[]} list of the different flat types under the median HDB resale prices database
 */

const FlatTypeDB = [
    "1-Room",
    "2-Room",
    "3-Room",
    "4-Room",
    "5-Room",
    "Executive",
];

export default FlatTypeDB;
